export enum PushType {
	ORDERS = 'ORDERS',
	COUPON = 'COUPON',
	RATING = 'RATING',
	NEWS = 'NEWS',
	CAMPAIGN = 'CAMPAIGN',
	QUEUE = 'QUEUE'
}
